// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__zsFzP","checkboxCol":"Table_checkboxCol__1LPGY","emailCol":"Table_emailCol__1Nmcg","actionCol":"Table_actionCol__3f9kl"};